import { z } from 'zod';
import { servicesProviderPricingFixedSchema, servicesProviderPricingFixedDtoSchema } from '../ServicesProviderPricing.js';
import { serviceConfigSchema } from './SharedServiceConfig.js';

/**
 * This is the service that handles the payout for the coverage product to the platform (i.e. Ekho in Omni, Ekho in Access)
 * We pay our cut of the coverage markup to this service
 * @example Payout breakdown:
 * - Coverage retail cost: $100
 * - Coverage markup: $10 (40% Ekho, 60% Dealer)
 * - Coverage tax: $5
 * - Coverage payout to platform service (coverage_platform): $40
 */
// ============================================================================
// Pricing Schemas
// ============================================================================
const coveragePlatformServicePricingSchema = servicesProviderPricingFixedSchema;
const coveragePlatformServicePricingDtoSchema = servicesProviderPricingFixedDtoSchema;
// ============================================================================
// Core Schema
// ============================================================================
const coveragePlatformServiceConfigSchema = serviceConfigSchema.extend({
    pricing: z.array(coveragePlatformServicePricingSchema),
});
// ============================================================================
// DTO Schema
// ============================================================================
const coveragePlatformServiceConfigDtoSchema = serviceConfigSchema.extend({
    pricing: z.array(coveragePlatformServicePricingDtoSchema),
});

export { coveragePlatformServiceConfigDtoSchema, coveragePlatformServiceConfigSchema, coveragePlatformServicePricingDtoSchema, coveragePlatformServicePricingSchema };
//# sourceMappingURL=CoveragePlatformServiceConfig.js.map
